export default __webpack_public_path__ + "static/share-4d3c3c676824afccc875c0ac6b0704d4.png";